import { render } from "./IconTextBold.vue?vue&type=template&id=0ac9ab27&ts=true"
import script from "./IconTextBold.vue?vue&type=script&lang=ts"
export * from "./IconTextBold.vue?vue&type=script&lang=ts"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__